import React, { forwardRef } from 'react';

/**
 * Componente de seleção (dropdown)
 * @param {Object} props - Propriedades do componente
 * @param {string} [props.label] - Label do componente
 * @param {string} [props.className] - Classes adicionais
 * @param {boolean} [props.disabled] - Se o componente está desabilitado
 * @param {React.ReactNode} props.children - Opções do select (MenuItem)
 * @returns {JSX.Element} Componente React
 */
const Select = forwardRef(({ 
  label, 
  className = '', 
  disabled = false, 
  children, 
  ...props 
}, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <select
        ref={ref}
        disabled={disabled}
        className={`
          w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm
          focus:outline-none focus:ring-blue-500 focus:border-blue-500
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
          ${className}
        `}
        {...props}
      >
        {children}
      </select>
    </div>
  );
});

Select.displayName = 'Select';

export default Select; 